export default function Footer() {
  return (
    <footer data-testid="main-footer" className="border-t border-white/10 py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-10">
          <div className="flex items-center gap-5">
            <div className="bg-white rounded-xl p-2 h-16 w-16 flex items-center justify-center">
              <img
                src="https://customer-assets.emergentagent.com/job_da530537-6bf8-4b66-af69-f5dc06fc17f9/artifacts/xlun0jwj_PLAYVERSE.png"
                alt="PlayVerse logo"
                className="h-full w-full object-contain"
                data-testid="footer-logo"
              />
            </div>
            <div>
              <div className="font-heading font-extrabold tracking-tighter text-xl">
                PLAY<span className="text-[#00D4FF]">VERSE</span>
              </div>
              <p className="font-mono-pv text-[10px] uppercase tracking-[0.2em] text-white/35 mt-1">
                Sports Simulator Solutions For Your Facility
              </p>
            </div>
          </div>

          <nav className="flex flex-wrap gap-x-8 gap-y-3">
            {[
              { label: "Why PlayVerse", href: "#why" },
              { label: "Systems", href: "#systems" },
              { label: "Numbers", href: "#numbers" },
              { label: "Contact", href: "#contact" },
            ].map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="font-mono-pv text-[11px] uppercase tracking-[0.2em] text-white/40 hover:text-[#00D4FF] transition-colors duration-300"
              >
                {l.label}
              </a>
            ))}
          </nav>
        </div>

        <div className="mt-14 pt-8 border-t border-white/[0.06] flex flex-col md:flex-row justify-between gap-4">
          <p className="font-mono-pv text-[10px] uppercase tracking-[0.15em] text-white/30">
            © {new Date().getFullYear()} PlayVerse. All rights reserved.
          </p>
          <p className="font-mono-pv text-[10px] uppercase tracking-[0.15em] text-white/30">
            Trusted by entertainment centers, cinemas & sports bars across North America
          </p>
        </div>
      </div>
    </footer>
  );
}
